// src/ssr/utils/RenderContext.ts
import { createContext } from "react";
var RenderContext = createContext({
  helmet: {}
});

export {
  RenderContext
};
//# sourceMappingURL=chunk-ALZ5FKDH.js.map
